/**
 * View Toggle - one or two products per row on mobile
 *
 * Sets a class on <body> rather than on the grid itself. facets.js replaces
 * the whole #ProductGridContainer on every filter and sort change, so a class
 * on the grid would be wiped; body survives. The choice is remembered so it
 * holds across page loads.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'knp_grid_columns';
  var BODY_CLASS = 'grid-view-1';

  function readStored() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function store(columns) {
    try { localStorage.setItem(STORAGE_KEY, columns); } catch (e) {}
  }

  function apply(columns) {
    document.body.classList.toggle(BODY_CLASS, columns === '1');
    document.querySelectorAll('[data-view-columns]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.dataset.viewColumns === columns ? 'true' : 'false');
    });
  }

  function boot() {
    var stored = readStored() === '1' ? '1' : '2';
    apply(stored);

    document.addEventListener('click', function (e) {
      var button = e.target.closest('[data-view-columns]');
      if (!button) return;
      e.preventDefault();
      var columns = button.dataset.viewColumns;
      store(columns);
      apply(columns);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  /**
   * facets.js rewrites the toolbar's innerHTML on every filter and sort
   * change, replacing the buttons with server-rendered ones that carry the
   * default pressed state. The layout stays correct (the class is on body)
   * but the control would show the wrong option as selected, so repaint the
   * pressed state whenever fresh buttons appear.
   */
  if (window.MutationObserver) {
    var repaintTimer = null;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if ((node.matches && node.matches('[data-view-columns]')) ||
              (node.querySelector && node.querySelector('[data-view-columns]'))) {
            clearTimeout(repaintTimer);
            repaintTimer = setTimeout(function () {
              apply(readStored() === '1' ? '1' : '2');
            }, 50);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
